import styled, { css } from 'styled-components'

export const ProductComparisonTable = styled.div``
